import { SchedulerType } from "../../../types";
import { callExternalApi } from "../../../core/services/external-api.service";

const apiServerUrl = process.env.REACT_APP_API_ORIGIN;

export const getOrganizations = async (accessToken: any) => {

    const config = {
        url: `${apiServerUrl}/admin/organization/all`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };

};

export const getOrganization = async (id: string, accessToken: any) => {

    const config = {
        url: `${apiServerUrl}/admin/organization/${id}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };

};

export const createOrganization = async (organization: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: organization
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

export const updateOrganization = async (id: string, organization: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${id}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: organization
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

export const deleteOrganization = async (id: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${id}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
}

export const addUser = async (user: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/user`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: user
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

export const getUser = async (userId: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/user/${userId}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

export const getUserByEmailAddress = async (emailAddress: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/user/email/${emailAddress}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

export const getProjects = async (accessToken: any, experience?: string) => {
    const config = {
        url: `${apiServerUrl}/admin/projects`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            ...(experience ? { experience: experience } : {})
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

export const getProject = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const getPDFSignedUrls = async (projectId: number, testUrl: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/signed?aws_url=${testUrl}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const createProject = async (project: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            projectName: project.name,
            projectType: project.type
        }
    }

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error
    }
};

export const updateProject = async (projectId: number, project: any, accessToken: any) => {
    let goalAttributes = '';

    let projectData = project;

    if (project.goals) {
        project.goals.forEach((element: any, idx: number) => {
            if (idx !== 0) goalAttributes += ", ";
            goalAttributes += element.value;
        });
        projectData = { ...project, goals: goalAttributes };
    }


    // This value is pulled from S3 on update.
    // Existing value is too large for request.
    project.lead_list = "";

    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: projectData
    }

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error
    }
};

export const deleteProject = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
}

export const loadStats = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/loadStats`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });
    return {
        data: data || null,
        error
    }
}

export const createConceptRevision = async (projectForm: any, conceptForm: any, accessToken: any) => {
    const body = {
        "use_case": projectForm.type,
        "goals": projectForm.goals.map((g: any) => g.value),
        "asset": projectForm.asset_text,
        "target_audience": projectForm.target_audience,
        "feedback": conceptForm.feedback,
        "guidance": conceptForm.guidance,
        "temperature": conceptForm.temperature
    };

    const config = {
        url: "http://18.219.107.9:8003/api/asset_generator_by_feedback",
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: body
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
};

export const getSurveyLinks = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/surveyLinks`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createSurveyLink = async (projectId: any, surveyLink: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/surveyLink`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: surveyLink
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getSurveyLink = async (projectId: any, surveyLinkId: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/surveyLink/${surveyLinkId}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateSurveyLink = async (projectId: any, surveyLinkId: any, surveyLink: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/surveyLink/${surveyLinkId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: surveyLink
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getViewpoints = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/viewpoints`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateViewpoint = async (projectId: number, viewpointId: number, viewpoint: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/viewpoint/${viewpointId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: viewpoint
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateViewpointAdvisor = async (projectId: number, viewpointId: number, advisorId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/viewpoint/${viewpointId}/advisor`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            advisor_id: advisorId
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const approveViewpoint = async (projectId: number, viewpointId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/viewpoint/${viewpointId}/approve`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const reprocessViewpoint = async (projectId: number, viewpointId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/viewpoint/${viewpointId}/reprocess`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const rejectViewpoint = async (projectId: number, viewpointId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/viewpoint/${viewpointId}/reject`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getNotifications = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/notification`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const refireNotification = async (projectId: number, notificationUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/notification/${notificationUuid}/refire`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}
export const sendDealNotification = async (projectId: number, notificationType: string, notificationForm: any, dealUpdateId: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/notification`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            notificationType: notificationType,
            subject: notificationForm.subject,
            headline: notificationForm.headline,
            body: notificationForm.body,
            dealUpdateId: dealUpdateId
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getDealUpdates = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/dealUpdates`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createDealUpdate = async (projectId: number, dealUpdate: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/dealUpdate`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: dealUpdate
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getDealUpdate = async (projectId: number, dealUpdateId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/dealUpdate/${dealUpdateId}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateDealUpdate = async (projectId: number, dealUpdateId: number, dealUpdate: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/dealUpdate/${dealUpdateId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: dealUpdate
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getInvestmentMaterials = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/investmentMaterials`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createInvestmentMaterial = async (projectId: number, investmentMaterial: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/investmentMaterial`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: investmentMaterial
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getInvestmentMaterial = async (projectId: number, investmentMaterialId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/investmentMaterial/${investmentMaterialId}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateInvestmentMaterial = async (projectId: number, investmentMaterialId: number, investmentMaterial: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/investmentMaterial/${investmentMaterialId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: investmentMaterial
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getAdvisors = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisors`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createAdvisor = async (projectId: number, advisor: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisor`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: advisor
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateAdvisor = async (projectId: number, advisorId: number, advisor: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisor/${advisorId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: advisor
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateViewpointProfile = async (viewpointId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/viewpoint/${viewpointId}/profile`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getCompanyByDomain = async (domain: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/viewpoint/company/${domain}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateCompany = async (companyId: number, company: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/viewpoint/company/${companyId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: company
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createCompany = async (company: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/company`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: company
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const refreshCompany = async (companyId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/company/${companyId}/enrich`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const deleteCompany = async (companyId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/company/${companyId}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getCompanies = async (accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/companies`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getLeads = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/leads`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const generateLeads = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/leads/generate`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const deleteLead = async (projectId: number, deletedLeadUuids: string[], accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/lead`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            lead_uuids: deletedLeadUuids
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const setLeadsAsPreferred = async (projectId: number, preferredLeadUuids: string[], accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/lead/preferred`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            lead_uuids: preferredLeadUuids
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const setLeadsAsNonPreferred = async (projectId: number, nonPreferredLeadUuids: string[], accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/lead/nonPreferred`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            lead_uuids: nonPreferredLeadUuids
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getTargetAudience = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/targetAudience`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getProjectMembers = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/members`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const addProjectMember = async (projectId: number, userId: number, role: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/member/${userId}`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            role: role
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const removeProjectMember = async (projectId: number, userId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/member/${userId}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateProjectMember = async (projectId: number, userId: number, role: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/member/${userId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            role: role
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getOrganizationMembers = async (organizationId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/members`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const addOrganizationMember = async (organizationId: number, memberForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/member`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: memberForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const removeOrganizationMember = async (organizationId: number, userId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/member/${userId}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateOrganizationMember = async (organizationId: number, userId: number, role: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/member/${userId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            role: role
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createMembership = async (membershipForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/membership`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: membershipForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateMembership = async (membershipId: string, membershipForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/membership/${membershipId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: membershipForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const deleteMembership = async (membershipId: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/membership/${membershipId}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const inviteProjectMember = async (projectId: number, invitationForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/member/invite`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: invitationForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getProjectInvitations = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/invitations`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const copyProjectToOrganization = async (projectId: number, organizationId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/copyProject`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            project_id: projectId
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const generateContributorLink = async (projectId: number, emailAddress: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/contributorLink`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            email_address: emailAddress
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateScheduler = async (projectId: number, type: string, schedulerForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/scheduler/${type}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: schedulerForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getScheduler = async (projectId: number, type: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/scheduler/${type}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const generateLeadsFromLinkedin = async (projectId: number, linkedInLeads: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/leads/linkedin`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            linkedin_leads: linkedInLeads
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getLinkedinSearches = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/linkedinSearches`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const addLinkedinSearch = async (projectId: number, linkedinSearchForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/linkedinSearch`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: linkedinSearchForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateLinkedinSearch = async (projectId: number, linkedinSearchUuid: string, linkedinSearchForm: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/linkedinSearch/${linkedinSearchUuid}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: linkedinSearchForm
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const deleteLinkedinSearch = async (projectId: number, linkedinSearchId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/linkedinSearch/${linkedinSearchId}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getPaidCampaigns = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/paidCampaigns`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const addPaidCampaign = async (projectId: number, campaignData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/paidCampaign`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: campaignData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updatePaidCampaign = async (projectId: number, campaignUuid: string, campaignData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/paidCampaign/${campaignUuid}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: campaignData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const deletePaidCampaign = async (projectId: number, campaignUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/paidCampaign/${campaignUuid}`,
        method: "DELETE",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateDefaultSurveyLink = async (projectId: number, surveyLinkId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/surveyLink/${surveyLinkId}/setDefault`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getPendingMessages = async (accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/messages/draft`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getSentMessages = async (accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/messages/sent`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateMessage = async (messageUuid: string, messageData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/message/${messageUuid}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: messageData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const sendMessage = async (messageUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/message/${messageUuid}/send`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getOrganizationDomains = async (organizationId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/domains`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const provisionOrganizationDomain = async (organizationId: number, domainUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/organization/${organizationId}/domain/${domainUuid}/provision`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const moveAdvisor = async (projectId: number, advisorId: number, newProjectId: number, newSurveyLinkId: number, newTouchpointId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisor/${advisorId}/move`,
        method: "PUT",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            new_project_id: newProjectId,
            new_survey_link_id: newSurveyLinkId,
            new_touchpoint_id: newTouchpointId
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const generateAdvisorHighlights = async (projectId: number, advisorUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisor/${advisorUuid}/highlights`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getAllMeetings = async (accessToken: any, experience?: string) => {
    const config = {
        url: `${apiServerUrl}/admin/reporting/meetings`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            ...(experience ? { experience: experience } : {})
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getAllMeetingsByTypes = async (accessToken: any, experience?: string, schedulerTypes?: SchedulerType[]) => {
    const config = {
        url: `${apiServerUrl}/admin/reporting/meetings`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            ...(experience ? { experience: experience } : {}),
            ...(schedulerTypes ? { types: schedulerTypes.join(",") } : {})
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getAllAdvisors = async (accessToken: any, experience?: string) => {
    const config = {
        url: `${apiServerUrl}/admin/advisors`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            ...(experience ? { experience: experience } : {})
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateMediaResponse = async (mediaResponseUuid: string, mediaResponseData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/mediaResponse/${mediaResponseUuid}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: mediaResponseData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getDomains = async (accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/domains`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateDomain = async (domainId: string, domainData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/domain/${domainId}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: domainData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateMeetingStatus = async (meetingUuid: string, status: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/meeting/${meetingUuid}/status`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            status: status
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const getProjectAdvisorSuggestions = async (projectId: number, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisorSuggestions`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateAdvisorSuggestion = async (projectId: number, advisorSuggestionUuid: string, advisorSuggestionData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/advisorSuggestion/${advisorSuggestionUuid}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: advisorSuggestionData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const createMeeting = async (meetingData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/meeting`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: meetingData
    }

    const { data, error } = await callExternalApi({ config });
}

export const updateMeeting = async (meetingUuid: string, meetingData: any, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/meeting/${meetingUuid}`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: meetingData
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const refreshMeeting = async (meetingUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/meeting/${meetingUuid}/refresh`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const refreshFirefliesSummary = async (meetingUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/meeting/${meetingUuid}/refresh-fireflies`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const refreshMeetgeek = async (meetingUuid: string, accessToken: any) => {
    const config = {
        url: `${apiServerUrl}/admin/meeting/${meetingUuid}/refresh-meetgeek`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        }
    }

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    }
}

export const updateSchedulerProperties = async (
    projectId: number,
    type: string,
    schedulerProperties: Record<string, any>,
    accessToken: any
) => {
    const config = {
        url: `${apiServerUrl}/admin/project/${projectId}/schedulerProperties`,
        method: "PATCH",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`
        },
        data: {
            type,
            ...schedulerProperties
        }
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error
    };
};

